export enum OwnerNameEnum {
  First = 'first',
  Full = 'full',
  Second = 'second'
}
